import React from "react";
import { SCHOOL_NAME } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import { Phone, MessageCircle, Mail, Globe } from "lucide-react";

export function HubungiKamiOrtu() {
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Hubungi Kami" />
      <section className="pp-card p-8 max-w-2xl">
        <h3 className="text-lg font-semibold text-slate-900 mb-4">{SCHOOL_NAME}</h3>
        <div className="space-y-4 text-sm">
          <a href="tel:07617876083" className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors" data-testid="contact-phone">
            <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center"><Phone className="w-5 h-5" /></div>
            <div><div className="text-xs text-slate-500">Telepon Sekolah</div><div className="font-medium">0761 7876083</div></div>
          </a>
          <a href="https://wa.me/6282288918993" target="_blank" rel="noreferrer" className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors" data-testid="contact-wa">
            <div className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center"><MessageCircle className="w-5 h-5" /></div>
            <div><div className="text-xs text-slate-500">WhatsApp Sekolah</div><div className="font-medium">0822 8891 8993</div></div>
          </a>
          <a href="mailto:slbpelitanusa@gmail.com" className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors" data-testid="contact-email">
            <div className="w-10 h-10 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center"><Mail className="w-5 h-5" /></div>
            <div><div className="text-xs text-slate-500">Email Sekolah</div><div className="font-medium">slbpelitanusa@gmail.com</div></div>
          </a>
          <a href="https://slbpelitanusa.sch.id" target="_blank" rel="noreferrer" className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors" data-testid="contact-web">
            <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-600 flex items-center justify-center"><Globe className="w-5 h-5" /></div>
            <div><div className="text-xs text-slate-500">Website Sekolah</div><div className="font-medium">slbpelitanusa.sch.id</div></div>
          </a>
        </div>
      </section>
    </Layout>
  );
}
